import { render, staticRenderFns } from "./RegionStorePane.vue?vue&type=template&id=bbe552d0&scoped=true"
import script from "./RegionStorePane.vue?vue&type=script&lang=js"
export * from "./RegionStorePane.vue?vue&type=script&lang=js"
import style0 from "./RegionStorePane.vue?vue&type=style&index=0&id=bbe552d0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe552d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbe552d0')) {
      api.createRecord('bbe552d0', component.options)
    } else {
      api.reload('bbe552d0', component.options)
    }
    module.hot.accept("./RegionStorePane.vue?vue&type=template&id=bbe552d0&scoped=true", function () {
      api.rerender('bbe552d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/RegionStorePane.vue"
export default component.exports